
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nutria-science",
      function () {
        return require("private-next-pages/nutria-science.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nutria-science"])
      });
    }
  